import type { Chapter } from '@code-arcade/engine'

export const chapter4: Chapter = {
  id: 'chapter-4',
  number: 4,
  title: 'Scale or Die',
  company: 'Omnitech Corp',
  devTitle: 'Staff Engineer L5',
  conflict: '50M users. Marketing wants segments in 90 seconds. The notification queue never drains.',
  intro: [
    { character: 'the-algorithm', mood: 'idle', dialogue: 'One year at Omnitech. 50 million users. Different class of problem.' },
    { character: 'dev-lama', mood: 'idle', dialogue: 'The recruiter said "scale challenges." She was not wrong.' },
    { character: 'vera-lox', mood: 'urgent', dialogue: 'Marketing needs the top-1000 user segments refreshed every 90 seconds. Your sort is taking 4 minutes.' },
    { character: 'dev-lama', mood: 'stressed', dialogue: 'We are sorting 50 million records to return 1,000 results.' },
    { character: 'grant-fielding', mood: 'idle', dialogue: 'You do not need them sorted. You need a threshold. Partition the array — find the boundary in one pass.' },
    { character: 'vera-lox', mood: 'idle', dialogue: 'How fast?' },
    { character: 'grant-fielding', mood: 'happy', dialogue: 'O(n). Every time. No full sort required.' },
  ],
  challengeIds: ['quickselect', 'heap-sort'],
}
